/** Column types stored in `database_schemas.columns[].type` (01-db.md). */
export const DATABASE_COLUMN_TYPES = [
  'text',
  'number',
  'date',
  'select',
  'multi_select',
  'checkbox',
  'relation',
  'rollup',
  'url',
] as const;

/** Removed from the picker; still accepted on schema PUT for existing columns. */
export const LEGACY_COLUMN_TYPES = ['email', 'phone'] as const;

export const SCHEMA_COLUMN_TYPES = [
  ...DATABASE_COLUMN_TYPES,
  ...LEGACY_COLUMN_TYPES,
] as const;

export type DatabaseColumnType = (typeof DATABASE_COLUMN_TYPES)[number];

const COLUMN_TYPE_LABELS: Record<DatabaseColumnType, string> = {
  text: 'Text',
  number: 'Number',
  date: 'Date',
  select: 'Select',
  multi_select: 'Multi-select',
  checkbox: 'Checkbox',
  relation: 'Relation',
  rollup: 'Rollup',
  url: 'URL',
};

/** User-facing label for a column type (stored value remains the enum string). */
export function columnTypeLabel(type: string): string {
  if (type in COLUMN_TYPE_LABELS) {
    return COLUMN_TYPE_LABELS[type as DatabaseColumnType];
  }
  return type
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (ch) => ch.toUpperCase());
}

export type DatabaseColumnDefinition = {
  id: string;
  name: string;
  type: DatabaseColumnType | string;
  config?: Record<string, unknown>;
};
